import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { UnifiedAuthProvider } from './UnifiedAuthContext';
import UnifiedLogin from './UnifiedLogin';
import UnifiedHome from './UnifiedHome';
import UnifiedPonto from './UnifiedPonto';
import UnifiedInconsistencias from './UnifiedInconsistencias';
import UnifiedMarcacoes from './UnifiedMarcacoes';
import UnifiedAprovacoes from './UnifiedAprovacoes';
import UnifiedNotificacoesDisciplinares from './UnifiedNotificacoesDisciplinares';
import UnifiedQuadroPresenca from './UnifiedQuadroPresenca';
import { Toaster } from '../../components/ui/sonner';

const UnifiedLayout = () => {
  return (
    <UnifiedAuthProvider>
      <Routes>
        <Route path="login" element={<UnifiedLogin />} />
        <Route path="ponto" element={<UnifiedPonto />} />
        {/* Redireciona justificativas para inconsistências - fluxo unificado */}
        <Route path="justificativas" element={<Navigate to="/unified/inconsistencias" replace />} />
        <Route path="inconsistencias" element={<UnifiedInconsistencias />} />
        <Route path="marcacoes" element={<UnifiedMarcacoes />} />
        <Route path="aprovacoes" element={<UnifiedAprovacoes />} />
        <Route path="disciplinares" element={<UnifiedNotificacoesDisciplinares />} />
        <Route path="quadro-presenca" element={<UnifiedQuadroPresenca />} />
        <Route path="" element={<UnifiedHome />} />
        <Route path="*" element={<Navigate to="/unified" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </UnifiedAuthProvider>
  );
};

export default UnifiedLayout;
